import React, { useEffect, useState } from "react";
import { Button, List, Table, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../Assets/Images/edit-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-icon.svg";
import TeamIcon from "../../../Assets/Images/teamIcon.svg";
import { TeamService } from "../../../Services/API/TeamsService";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import tableCellRender from "../../../Components/TableCellRender/tableCellRender";
import AlertModal from "../../../Components/AlertModal/AlertModal";
import { Gid } from "../../../Utils/constants";

export default function TeamsListing() {
  const navigate = useNavigate();
  const windowWidth = window.innerWidth;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [teamToDelete, setTeamToDelete] = useState(null);

  const fetchTeams = () => {
    setLoading(true);
    TeamService.getAllTeams()
      .then((response) => {
        setTeams(response?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data || "Failed to fetch teams.");
        console.log(error);
      });
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  const showDeleteModal = (team) => {
    setTeamToDelete(team);
    setIsDeleteModalVisible(true);
  };

  const handleDelete = () => {
    if (teamToDelete) {
      const idWithoutQuotes = teamToDelete?.id?.replace(/"/g, "");
      const encodedId = encodeURIComponent(idWithoutQuotes);
      TeamService.deleteTeam(encodedId)
        .then((response) => {
          toast.success("Team deleted successfully!");
          fetchTeams();
          setIsDeleteModalVisible(false);
          setTeamToDelete(null);
        })
        .catch((error) => {
          toast.error(error?.response?.data || "Failed to delete team.");
          console.log(error);
          setIsDeleteModalVisible(false);
          setTeamToDelete(null);
        });
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setTeamToDelete(null);
  };

  const showModal = (teamMembers) => {
    setSelectedTeamMembers(teamMembers);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Team Name",
      dataIndex: "team_title",
      key: "team_title",
      width: windowWidth > 1024 ? 200 : 150,
      fixed: "left",
      ellipses: true,
      sorter: (a, b) => a.team_title.localeCompare(b.team_title),
      render: (value) => tableCellRender(value, "single-val"),
    },
    {
      title: "Team Members",
      dataIndex: "members",
      key: "members",
      width: 300,
      ellipsis: true,
      render: (value) =>
        tableCellRender(value.slice(0, 2), "array-of-participants"),
    },
    {
      title: " ",
      dataIndex: "members",
      key: "team_icon",
      width: 120,
      render: (value) => {
        return (
          <div className="table-title-div">
            {value?.length > 2 && (
              <Button type="link" onClick={() => showModal(value)}>
                <img src={TeamIcon} alt="Team Members" className="team-icon" />
              </Button>
            )}
          </div>
        );
      },
    },
    {
      title: "Member Count",
      dataIndex: "members",
      key: "members_count",
      width: 120,
      render: (value) => tableCellRender(value, "count"),
    },
    {
      title: " ",
      dataIndex: "",
      key: "actions",
      width: 120,
      render: (value, row) => {
        return (
          <div className="actions-div">
            <div className="edit-team-container">
              <img
                className="actions-icons"
                src={editIcon}
                onClick={() =>
                  navigate("/teams", {
                    state: { action: "edit", data: value },
                  })
                }
                alt="Edit team"
              />
            </div>
            <div
              className="delete-team-container"
              onClick={() => showDeleteModal(value)}
            >
              <img
                className="actions-icons"
                src={deleteIcon}
                alt="Delete team"
              />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="listing-page">
      <div className="listing-header-container">
        <div className="heading">Teams</div>
        <div className="add-btn-container">
          <Button
            className="add-btn"
            onClick={() =>
              navigate("/teams", {
                state: { action: "add", data: "" },
              })
            }
          >
            Add New Team
          </Button>
        </div>
      </div>
      <div className="table-container">
        {loading ? (
          <Loader />
        ) : (
          <Table
            className="table-class"
            columns={columns}
            dataSource={teams}
            scroll={{
              x: "auto",
            }}
          />
        )}
      </div>
      <Modal
        title="Team Members"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <List
          dataSource={selectedTeamMembers}
          renderItem={(member) => (
            <List.Item>
              {member?.participant_first_name} {member?.participant_last_name} (
              {member?.participant_email})
            </List.Item>
          )}
        />
      </Modal>
      {isDeleteModalVisible && (
        <AlertModal
          openModal={isDeleteModalVisible}
          closeModal={handleCancelDelete}
          handleYes={handleDelete}
          title={"team"}
        />
      )}
    </div>
  );
}
